module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-proforma-to-credit-note"
  }, [_c('ModalReveal', {
    on: {
      "input": _vm.closeReveal
    },
    model: {
      value: (_vm.openReveal),
      callback: function($$v) {
        _vm.openReveal = $$v
      },
      expression: "openReveal"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    on: {
      "click": _vm.open
    },
    slot: "trigger"
  }, [_vm._v("Make credit note")]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Refund on gateway"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refund_on_gateway),
      expression: "refund_on_gateway"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.refund_on_gateway) ? _vm._i(_vm.refund_on_gateway, null) > -1 : (_vm.refund_on_gateway)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.refund_on_gateway,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.refund_on_gateway = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.refund_on_gateway = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.refund_on_gateway = $$c
        }
      }
    }
  })])])])]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.convertToCreditNote,
      "confirm": true
    },
    slot: "footer"
  }, [_vm._v("Make Credit note")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-edcbed7a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/ConvertProformaToCreditNote.vue
// module id = 2724
// module chunks = 1